import moment from 'moment';
import { ConfigConstants } from '../../config/config-constants';
import { ModelOptions } from './model-options';

/**
 *  Configure the behaviour of a DateModel
 */
export class TimeModelOptions extends ModelOptions {
    public readonly format: string;
    public readonly maxValue: moment.Moment;
    public readonly minValue: moment.Moment;
    public readonly readonly: boolean;
    public readonly displaySeconds: boolean;
    public static readonly defaultMaxValue: moment.Moment = moment(0).add(ConfigConstants.maxAmountOfYears, 'years');
    public static readonly defaultMinValue: moment.Moment = moment(0);

    /**
     * Constructor that expects an object with some or all of the supported options set
     *
     * @param root0
     * @param root0.format
     * @param root0.maxValue
     * @param root0.minValue
     * @param root0.readonly
     * @param root0.displaySeconds
     */
    public constructor({
        format = ConfigConstants.formatXSDTimeDuration,
        maxValue = TimeModelOptions.defaultMaxValue.clone(),
        minValue = TimeModelOptions.defaultMinValue.clone(),
        readonly = false,
        displaySeconds = false,
    }: {
        format?: string;
        maxValue?: moment.Moment;
        minValue?: moment.Moment;
        readonly?: boolean;
        displaySeconds?: boolean;
    } = {}) {
        super();
        this.format = format;
        this.maxValue = maxValue.clone();
        this.minValue = minValue.clone();
        this.readonly = readonly;
        this.displaySeconds = displaySeconds;
    }
}

export class TimeModelOptionsFromJson extends TimeModelOptions {
    public constructor(data: JsonTimeModelOptions) {
        super({
            format: data.format,
            maxValue: moment(data.maxValue),
            minValue: moment(data.minValue),
            readonly: data.readonly,
            displaySeconds: data.displaySeconds,
        });
    }
}

export interface JsonTimeModelOptions {
    format: string;
    maxValue: string;
    minValue: string;
    readonly: boolean;
    displaySeconds: boolean;
}
